<form class="material-list">
  <mat-form-field>
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    <input type="text" [placeholder]="placeHolder" aria-label="Number" matInput [formControl]="myControl"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let material of filteredMaterials | async" [value]="material">
        {{material?.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-mini-fab *ngIf="displayAddButton" type="button" style="margin-left: 10px;" (click)="createMaterial()" [matTooltip]="'label.add-entry' | translate">
    <mat-icon>add</mat-icon>
  </button>
</form>

<!-- <form class="material-list">
  <mat-form-field>
    <mat-select [formControl]="myControl">
      <mat-option *ngFor="let material of materials" [value]="material">
         {{material?.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form> -->